<template>
  <div>
    <a href="#" @click.prevent="tLogin">
      <span class="sns-center">
        <span class="icon-sns icon-tworld"></span>
        <span class="txt-sns">T아이디로 시작하기</span>
      </span>
    </a>
  </div>
</template>

<script>
  import { parseUrl } from 'query-string'
  import utils from '@/common/util/utils'
  import { URL_PROTOCOL_DOMAIN } from '@/common/constant'

  export default {
    name: 'BtnSkt',
    props: {
      promotionCode: {
        type: String,
      },
    },
    data() {
      return {
        signupResultCode: '302',
      }
    },
    methods: {
      /**
       * URL의 query parameter 내 referer에서 promotioncode를 추출
       * (예: referer=https://www.example.com?promotioncode=12345)
       */
      getPromotionCode() {
        const { referer } = this.$route?.query || {}
        const { query: refererQuery } = parseUrl(decodeURIComponent(referer))
        const { promotioncode: promotionCode = '' } = refererQuery || {}
        return promotionCode
      },
      tLogin() {
        const promotionCode = this.getPromotionCode()
        const callbackUrl = utils.queryString.concatParams(
          URL_PROTOCOL_DOMAIN + '/tcallback.html',
          {
            state:
              promotionCode !== ''
                ? encodeURIComponent(`promotioncode=${promotionCode}`)
                : '',
          },
        )

        const loginUrl = utils.login.getMemberSnsLoginUrl({
          type: 'tid',
          callback: callbackUrl,
        })
        location.href = loginUrl
      },
    },
  }
</script>
